import React from "react";
import { Field, useFormikContext } from "formik";

interface MaskedInputProps {
  name: string;
  placeholder: string;
  className?: string;
}

const MaskedCpfCnpjField: React.FC<MaskedInputProps> = ({
  name,
  placeholder,
  className,
}) => {
  const { values, setFieldValue } = useFormikContext<any>();
  const value = values[name] || "";

  function formatCpfCnpj(val: string) {
    const cleaned = val.replace(/\D/g, "");
    if (cleaned.length <= 11) {
      return cleaned
        .replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, "$1.$2.$3-$4")
        .replace(/[-.]$/, "");
    } else {
      return cleaned
        .replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})/, "$1.$2.$3/$4-$5")
        .replace(/[-/.]$/, "");
    }
  }

  return (
    <>
      <Field
        className={className}
        name={name}
        type="text"
        placeholder={placeholder}
        value={formatCpfCnpj(value)}
        onChange={(e) => setFieldValue(name, e.target.value)}
        maxLength={18}
      />
    </>
  );
};

export default MaskedCpfCnpjField;
